exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".template-img[data-v-b3bec16c]{width:60px;height:60px;object-fit:cover;border:1px solid #ebeef5;border-radius:4px;cursor:pointer}.preview-wrapper[data-v-b3bec16c]{text-align:center}.preview-wrapper img[data-v-b3bec16c]{max-width:100%}.status-active[data-v-b3bec16c]{color:#67c23a}.status-disabled[data-v-b3bec16c]{color:#909399}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-b3bec16c&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/OperationManage/UserAdminister/ShareTemplate/ShareTemplate.vue
// module id = 618
// module chunks = 0